import React from "react";
import "../css/Footer.css"; // Importing the CSS file
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container2">
        <div className="footer-grid">
          {/* Sinocare Brand, Social Icons, and Address - One Block */}
          <div className="footer-main">
            <NavLink to="/">
              <img
                src="/images/image_white.png"
                alt="Dr.Chek Logo"
                className="footer-brand "
              />
            </NavLink>

            <p className="footer-address">
              <i className="fas fa-map-marker-alt"></i> Royal Wave Biotech
              Private Limited <br></br> Ground Floor, House 7-100/69, Plot
              No.69, Balaji Nagar Colony, Qutubullapur, Nizampet, Hyderabad,
              Telangana 500090
            </p>
            <div className="footer-social">
              {[
                {
                  icon: "fab fa-facebook",
                  link: "https://www.facebook.com/DrChekHealth/",
                },
                {
                  icon: "fab fa-instagram",
                  link: "https://www.instagram.com/drchekhealth/",
                },
                { icon: "fab fa-twitter", link: "https://x.com/drchekhealth" },
                {
                  icon: "fab fa-youtube",
                  link: "https://www.youtube.com/@drchekhealth",
                },
                {
                  icon: "fab fa-linkedin",
                  link: "https://www.linkedin.com/company/drchekhealth/",
                },
              ].map((social, index) => (
                <a key={index} href={social.link} className="social-icon">
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-column">
            <h2 className="footer-heading">Quick Links</h2>
            <ul>
              {[
                { name: "Home", link: "/" },
                { name: "About Us", link: "/about" },
                { name: "Products", link: "/products" },
                { name: "Contact Us", link: "/contact" },
              ].map((item, index) => (
                <li key={index}>
                  <Link to={item.link}>{item.name}</Link>{" "}
                  {/* Changed href to to */}
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h2 className="footer-heading">Products</h2>
            <ul>
              {[
                { name: "Blood Glucose ", link: "/blood-glucose-meter" },
                { name: "Blood Pressure", link: "/blood-pressure-meter" },
                { name: "Blood Hemoglobin", link: "/Hemoglobin-meter" },
                
              ].map((item, index) => (
                <li key={index}>
                  <Link to={item.link}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Us */}
          <div className="footer-column">
            <h2 className="footer-heading">CONTACT US</h2>
            <ul>
              <li></li>
              <li>
                Email: <a href="mailto:info@drcheck.com">info@drchek.com</a>
              </li>
              <li>
                Phone: <a href="tel:+91 40 3516 9152">+91 40 3516 9152</a>{" "}
                {/* Replace with your number */}
              </li>
              <li>Service Hours: Mon-Sat, 9:00 AM - 5:30 PM</li>
              <li>
                Location:{" "}
                <a
                  href="https://www.google.com/maps/search/Royal+Wave+Biotech+%28Dr.Chek%29"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Google Maps
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Notice */}
        <div className="footer-copyright">
          <p>
            © {new Date().getFullYear()} Drchek All Rights Reserved | Designed and
            Maintained by {" "}
            <a
              style={{ color: "#ffff", textDecoration: "none" }}
              href="https://skyhitmedia.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              SKYHIT MEDIA
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
